import baseService from "@/services/Base-service";

class BaseInformationService {

    getListProvince() {
        return baseService.get('/BaseInformation/GetListProvince');
    }

    getListCity(provinceId) {
        return baseService.get('/BaseInformation/GetListCity/' + provinceId);
    }

    selectSchools(provinceId, countyId) {
        return baseService.get('/BaseInformation/SelectSchools/' + provinceId + '/' + countyId);
    }

    schoolsInsert(provinceId, countyId, jsonData) {
        return baseService.get('/BaseInformation/SchoolsInsert/' + provinceId + '/' + countyId + '/' + jsonData);
    }

}
export default new BaseInformationService();